import { EDynamicAvailabilityType, ETimeScope } from '@timeedit/types';

// Rolling days (unitCount) only applies to daily Max available hours /
// Max available reservations
export const ROLLING_DAYS_TYPES = [
  EDynamicAvailabilityType.TOTAL_HOURS,
  EDynamicAvailabilityType.TOTAL_RESERVATIONS,
];

export const supportsRollingDays = (
  type: EDynamicAvailabilityType,
  scopeType?: string
) => ROLLING_DAYS_TYPES.includes(type) && scopeType === ETimeScope.DAILY;
